import { Grid } from "@mui/material";
import { AloveSwitch } from "components/alove/AloveSwitch";
import { DropdownButton } from "components/alove/DropDownButton";
import { DealbrakerType, Question } from "models/batch/Question";

export const AlgorithmSettings = ({
  question,
  setQuestion,
}: {
  question: Question;
  setQuestion: Function;
}) => {
  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <AloveSwitch
          title="Core Question"
          subtitle="This question is a core question, and can't be modified or deleted."
          value={question.isCore}
          setValue={(value: boolean) => setQuestion({ ...question, isCore: value })}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <AloveSwitch
          title="Used For Scoring"
          subtitle="This question is used for scoring the match percentage."
          value={question.usedForScoring}
          setValue={(value: boolean) => setQuestion({ ...question, usedForScoring: value })}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <DropdownButton
          label={DealbrakerType[question.isDealBreaker]}
          enum={DealbrakerType}
          onClick={(option) => setQuestion({ ...question, isDealBreaker: option.value })}
          title="Deal Breaker"
          subtitle="Full deal breakers will exclude a match if one answer is empty. Partial deal breakers will exclude a match only if both parties answer the question, and the answers don't match."
        />
      </Grid>
    </Grid>
  );
};
